// Swiper
(() => {
  const section = document.querySelector(".subscription-slider");
  const swiperElement = section.querySelector(".swiper");
  const slides = section.querySelectorAll(".swiper-slide");

  if (!section || !swiperElement || !slides) {
    return;
  }

  const settings = {
    autoHeight: true,
    allowTouchMove: false,
  };

  const pagination = section.querySelector(".swiper-pagination");

  if (pagination !== null) {
    settings.pagination = {
      el: pagination,
      clickable: true,
    };
  }

  const swiper = new Swiper(swiperElement, settings);

  window.theme.subscriptionSlider = { swiper, pick: [] };

  // Pagination
  function handlePagination(evt, index) {
    if (!slides[index].dataset.selected) {
      evt.preventDefault();
      evt.stopPropagation();
      return;
    }

    window.theme.subscriptionSlider.pick =
      window.theme.subscriptionSlider.pick.slice(0, index);
  }

  section
    .querySelectorAll(".swiper-pagination-bullet")
    .forEach((bullet, index) => {
      bullet.classList.add("h1");
      bullet.textContent = `${index + 1}`;
      bullet.dataset.option = slides[index].dataset.option;
      bullet.addEventListener("click", (evt) => handlePagination(evt, index));
    });
})();

// Main
(() => {
  const section = document.querySelector(".subscription-slider");

  if (!section) {
    return;
  }

  const options = [
    ...section.querySelectorAll(".swiper-slide--subscription-plan button"),
  ]
    .map((button) => JSON.parse(button.dataset.variantsOptions || "[]"))
    .flat();

  if (!options.length) {
    return;
  }

  // const checkoutLink = section.querySelector(
  //   ".subscription-slider__checkout-link"
  // );

  // if (!checkoutLink) {
  //   return;
  // }

  function checkNextAvailability(slide) {
    let find;

    for (const button of slide.nextElementSibling?.querySelectorAll("button") ||
      []) {
      if (!button.dataset.value) {
        continue;
      }

      let found = false;

      find = JSON.stringify(
        window.theme.subscriptionSlider.pick.concat(button.dataset.value)
      );

      for (const option of options) {
        if (JSON.stringify(option) === find) {
          found = true;
          break;
        }
      }

      if (!found) {
        button.setAttribute("disabled", true);
      } else {
        button.removeAttribute("disabled");
      }
    }
  }

  function updateChoice(evt) {
    const button = evt.target.closest("button") || evt.target;
    const slide = button.closest(".swiper-slide");

    let variant = "";

    [...button.parentElement.children].forEach((item) => {
      item.classList.remove("is-selected");
    });

    button.classList.add("is-selected");

    if (button.dataset.name !== "product") {
      window.theme.subscriptionSlider.pick[button.dataset.position - 1] =
        button.dataset.value;
      slide.dataset.selected = "true";

      // Check next availability
      checkNextAvailability(slide);

      window.theme.subscriptionSlider.swiper.slideNext();
    } else {
      const sellingPlan = button.dataset.sellingPlan;
      const variantsIds = JSON.parse(button.dataset.variantsIds);
      const variantsOptions = JSON.parse(button.dataset.variantsOptions);

      if (!sellingPlan || !variantsIds || !variantsOptions) {
        return;
      }

      const variantIndex = variantsOptions.findIndex(
        (variantOption) =>
          JSON.stringify(variantOption) ===
          JSON.stringify(window.theme.subscriptionSlider.pick)
      );

      if (variantIndex !== -1) {
        window.location.href = `/cart/clear?return_to=/cart/add?items[][id]=${variantsIds[variantIndex]}%26items[][quantity]=1%26items[][selling_plan]=${sellingPlan}%26return_to=/checkout`;
        // checkoutLink.click();
      } else {
        console.log("No variant found");
      }
    }
  }

  section.querySelectorAll(".subscription-slider button").forEach((button) => {
    button.addEventListener("click", updateChoice);
  });
})();
